module.exports = __webpack_public_path__ + "work_bg.7aa2b399206efbc7e49f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/work_bg.png
// module id = 473
// module chunks = 1